export function getDistance(el1, el2) {
  const rect1 = el1.getBoundingClientRect()
  const rect2 = el2.getBoundingClientRect()
  const horizontalDistance = Math.abs(rect1.left - rect2.left)
  const verticalDistance = Math.abs(rect1.top - rect2.top)
  return { horizontalDistance, verticalDistance }
}



// WEBPACK FOOTER //
// ./src/public/utils/dom.js